import { createId } from '@vms/vmspro3-core/dist/idUtils'

const clientId = createId()

// this is a unique client ID to help prevent action loops.  the user ID is not sufficient,
// as the same user may be using OptionLab from different browsers/devices
export default clientId
